// extracted by mini-css-extract-plugin
export default {"root":"stylesDefault-modules__root__p95Zp","show-keyframe":"stylesDefault-modules__show-keyframe__YpLFV"};